var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCdCase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M22 13.4697C22 18.9927 17.523 23.4697 12 23.4697C6.477 23.4697 2 18.9927 2 13.4697C2 7.94773 6.477 3.46973 12 3.46973C17.523 3.46973 22 7.94773 22 13.4697Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7843 17.2374C10.776 17.2374 9.14807 15.6096 9.14807 13.6014C9.14807 11.5934 10.7759 9.96545 12.7843 9.96545C14.7923 9.96545 16.4202 11.5933 16.4202 13.6014C16.4202 15.6095 14.7923 17.2374 12.7843 17.2374ZM8.65234 9.46973V17.7331H16.916V9.46973H8.65234Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7845 15.0889C11.963 15.0889 11.297 14.4229 11.297 13.6014C11.297 12.78 11.963 12.1139 12.7845 12.1139C13.606 12.1139 14.272 12.7799 14.272 13.6014C14.272 14.4229 13.606 15.0889 12.7845 15.0889ZM12.7845 11.6182C11.6891 11.6182 10.8013 12.506 10.8013 13.6014C10.8013 14.6969 11.6892 15.5847 12.7845 15.5847C13.8799 15.5847 14.7678 14.6967 14.7678 13.6014C14.7678 12.506 13.8799 11.6182 12.7845 11.6182Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.82642 17.2374H7.33057V9.96545H7.82642V17.2374ZM7 9.46973V17.7331H8.15687V9.46973H7Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCdCase);
export default __webpack_public_path__ + "static/media/cd_case.f42383405c38ae3843269694294b6ee9.svg";
export { ForwardRef as ReactComponent };